<div class="flex align-items-center justify-content-center text-center flex-column gap-3">
	<div>{{ 'BETA_FE_TXT_R1_DIALOG' | translate }}</div>
	<div>{{ 'BETA_FE_TXT_R2_DIALOG' | translate }}</div>
</div>